// if you change something also change: packages/server/api/types/WriteAccess.ts
export enum WriteAccessEnum {
  AUTHORIZED_MEMBERS_ONLY = 'authorized_members_only',
  ANONYMOUS_APPROVED = 'anonymous_approved',
  ANONYMOUS_UNAPPROVED = 'anonymous_unapproved',
}
